import React from "react";
import { Container } from "@material-ui/core";
import Breadcum from "../../common/breadcum";
import ReportByCoverage from "./reportByCoverage";

const ReporteCobertura = (props) => {
  const project = props.location.state.data;
  const listBreadcrumbs = [
    {
      path: `/proyectos/`,
      label: "Proyectos",
    },
  ];
  return (
    <Container maxWidth="md">
      <Breadcum
        onListBreadcrumbs={listBreadcrumbs}
        lastLabel={"Reporte Proyectos por Cobertura"}
      />
      <h1> REPORTE DE PROYECTOS POR COBERTURA</h1>
      <ReportByCoverage data={project} />
    </Container>
  );
};

export default ReporteCobertura;
